import {
  SelectOption as RexSelectOption,
  ConfigProvider as RexConfigProvider,
  theme,
} from 'ant-design-vue';

export { RexSelectOption, RexConfigProvider, theme };
export const REX_TABLE_INFINITE_SCROLL_THROTTLE_TIME = 500;
